import { View } from './view'

export const Faq = View
